module.exports = __webpack_public_path__ + "img/img8.a0c9db31.svg";